export const apiUrls = {
  auth: {
    login: 'v1/auth/login',
    logout: 'v1/auth/logout',
    ssoLogin: (companyId: string) => `v1/auth/sso/login/${companyId}`, // browser GET → Nest → IdP
    registrationRequest: 'v1/auth/registration-request',
    passwordResetRequest: 'v1/auth/password-reset-request',
    resetPassword: 'v1/auth/update-password',
    updatePasswordForUser: 'v1/auth/update-password/my',
    validatePasswordResetToken: 'v1/auth/validate-reset-token',
  },
  accessControl: {
    selectNewUserRole: 'v1/access-control/roles/new-user',
  },
  users: {
    baseUsers: 'v1/users',
    me: 'v1/users/me',
    wishlist: 'v1/users/wishlist',
    company: 'v1/users/me/company',
    enableDealActiveNotification: 'v1/users/deal-notification',
    newsletter: {
      subscribe: 'v1/newsletter/subscribe',
      unsubscribe: 'v1/newsletter/unsubscribe',
      getMySubscription: 'v1/newsletter/subscriptions/my',
    },
  },
  benefits: {
    appConfig: 'v1/benefits/app-config',
    addresses: {
      base: 'v1/benefits/addresses',
      my: 'v1/benefits/addresses/my',
    },
    brands: {
      getAllBrands: 'v1/benefits/brands/company/list',
    },
    deals: {
      getDealById: 'v1/benefits/deals',
      getDeals: 'v1/benefits/deals',
      getDealsByCategory: 'v1/benefits/deals/category',
      getDealsByBrand: 'v1/benefits/deals/brand',
      getFilters: 'v1/benefits/deals/filters',
      search: 'v1/benefits/deals/search',
      getSearchSuggestions: 'v2/benefits/deals/search/suggestions',
      getIdleSearchSuggestions: 'v2/benefits/deals/search/suggestions/idle',
      getLocalDeals: 'v1/benefits/deals/local',
      generateDynamicCouponCode: 'v1/benefits/deals/generateDynamicCouponCode',
      submitSurveyForm: 'v1/benefits/deals/survey',
      crossSellingDeals: (dealId: string) => `v1/benefits/deals/${dealId}/cross-selling`,
    },
    dealLocations: {
      getDealLocationsByDealId: (dealId: string) => `v1/deal-location/deal/${dealId}`,
    },
    categories: {
      getCategories: 'v1/benefits/categories',
      getCategoryById: (categoryId: string) => `v1/benefits/categories/detail/${categoryId}`,
      getSubcategoriesByCategoryId: (categoryId: string) =>
        `v1/benefits/categories/detail/${categoryId}`,
      getCategoryPage: 'v1/benefits/categories/pagecontent',
    },
    campaigns: {
      getActiveCampaign: 'v1/benefits/campaigns/store/my',
    },
    adventCalendar: {
      getAdventCalendar: 'v1/advent-calendars',
      getItems: (adventCalendarId: string) => `v1/advent-calendars/${adventCalendarId}/items`,
    },
    cart: {
      items: {
        calculateTotal: 'v2/benefits/carts/items/calculate',
      },
    },
    couponOptions: {
      getCouponOptionsByDealId: 'v1/benefits/coupon-options/deal',
    },
    purchases: {
      base: 'v1/benefits/purchases',
      my: 'v1/benefits/purchases/my',
      createPaymentIntent: 'v1/benefits/payments/payment-intent',
      createWithdrawal: (purchaseId: string) => `v1/benefits/purchases/${purchaseId}/withdrawal`,
    },
    companies: {
      bySubdomainAndTld: (subdomain: string, tld: string) =>
        `v1/benefits/stores/by-domain/${subdomain}/${tld}`,
      my: 'v1/users/me/company',
      getCompaniesShort: 'v1/benefits/stores',
      validateEmailDomain: (id: string) => `v1/benefits/stores/${id}/validate-email-domain`,
      getPotentialCompanies: 'v1/benefits/stores/potential',
    },
  },
  pages: {
    getFullPageForCompany: `v1/pages`,
    getFullPageByCompanyCategoryId: (categoryId: string) => `v1/pages/category/${categoryId}`,
  },
  contacts: {
    createContact: 'v1/contacts',
  },
  feedbacks: {
    createFeedback: 'v1/feedbacks',
  },
};
